<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          あなたのWebページの外部参照数は適切です。
        </p>
        <p v-else>
          あなたのWebページの外部参照数が20以上あるためページの読み込みに影響を及ぼしています。
        </p>
      </div>
    </li>
    <li
      v-if="detail.totalCount || detail.totalCount === 0"
      class="c-list--checkup__item"
    >
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <p>Webページからの外部参照ファイル数は{{ detail.totalCount }}です。</p>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>外部参照のページを20以下に減らして下さい。</p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  }
};
</script>
